import { call, fork, put, take, select } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';
import { refNumber } from '../refNumber';

// function* postRequestTc(tcRequest, keyTcOrder) {
//     const response = yield call(api.postRequestTc, tcRequest);

//     if (response.data) {
//         yield put({
//             type: actionTypes.POST_TC_REQUEST.SUCCESS,
//             data: response.data,
//             tcRequest,
//         });

//         yield put({
//             type: actionTypes.ADD_NOTIFICATION,
//             notification: {
//                 title: `Success tc request - ${keyTcOrder + 1}`,
//                 message: 'TC request created successfully',
//                 level: 'success',
//                 _id: new Date().getMilliseconds(),
//                 autoDismiss: 10,
//             },
//         });

//         yield call(refNumber, response.data);
//         return response;
//     }

//     yield put({
//         type: actionTypes.ADD_NOTIFICATION,
//         notification: {
//             title: `Error tc request - ${keyTcOrder + 1}`,
//             message: response.errors[0].message || response.errors[0].messages[0],
//             level: 'error',
//             _id: new Date().getMilliseconds(),
//             autoDismiss: 10,
//         },
//     });

//     yield put({
//         type: actionTypes.POST_TC_REQUEST.FAILURE,
//         errors: response.errors,
//         tcRequest,
//     });

//     return response;
// }

// export function* watchPostRequestTc() {
//     while (true) {
//         const { tcRequest, index } = yield take(actionTypes.POST_TC_REQUEST.REQUEST);
//         yield fork(postRequestTc, tcRequest, index);
//     }
// }

function* getIndexesTc(filter) {
    const response = yield call(api.getTcHireIdeas, filter);

    if (response.data) {
        yield put({
            type: actionTypes.GET_TC_INDEXES.SUCCESS,
            data: response,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_TC_INDEXES.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetIndexesTc() {
    while (true) {
        const { filter } = yield take(actionTypes.GET_TC_INDEXES.REQUEST);
        yield fork(getIndexesTc, filter);
    }
}

// function* deleteRequestsTc(tcRequestId) {
//     const response = yield call(api.deleteTcRequest, tcRequestId);

//     if (response.data._id) {
//         const store = yield select();

//         yield put({
//             type: actionTypes.DELETE_TC_REQUEST.SUCCESS,
//             tcRequestId,
//             email: store.user.user.email,
//         });

//         yield put({
//             type: actionTypes.ADD_NOTIFICATION,
//             notification: {
//                 title: 'Success',
//                 message: "Request deleted successfully",
//                 level: 'success',
//                 _id: tcRequestId,
//                 autoDismiss: 2,
//             },
//         });
//         return;
//     }

//     yield put({
//         type: actionTypes.DELETE_TC_REQUEST.FAILURE,
//         tcRequestId,
//         error: response.errors,
//     });

//     yield put({
//         type: actionTypes.ADD_NOTIFICATION,
//         notification: {
//             title: 'Error',
//             message: response.errors[0].message,
//             level: 'error',
//             _id: tcRequestId,
//             autoDismiss: 2,
//         },
//     });

// }

// export function* watchDeleteRequestsTc() {
//     while (true) {
//         const { tcRequestId } = yield take(actionTypes.DELETE_TC_REQUEST.REQUEST);
//         yield fork(deleteRequestsTc, tcRequestId);
//     }
// }

export default [
    // watchPostRequestTc,
    watchGetIndexesTc,
    // watchDeleteRequestsTc,
];



// WEBPACK FOOTER //
// ./app/sagas/tc/indexes.js